import { Button, Form, Row, Space } from "antd";
import { AdvancedForm } from "../../form/advanced-form";
import FormItem from "../../form/form-item";
import { useCallback } from "react";
import { useSelector } from "react-redux";
import WorktimeTable from "../../fragments/worktime-table";
import { ActionTableState } from "../../action-table/action-table";
import dayjs from "dayjs";
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc)

function CustomerInvoiceDetails({ customerId, invoiceId }) {
  const [form] = Form.useForm();
  const userToken = useSelector(state => (state as any).user?.userToken);

  const generatePdf = useCallback(async () => {
    
      const body = {
        customerId,
        invoiceDate: dayjs("2025-05-14").utc().format('YYYY-MM-DDTHH:mm:ss') + '.000Z',
        deliveryDate: dayjs("2025-04-30").utc().format('YYYY-MM-DDTHH:mm:ss') + '.000Z',
      }

      const response = await fetch("/api/plamo/invoice/pdf", { method: 'POST', body: JSON.stringify(body), headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${userToken}` } });
      const blob = await response.blob()
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a") as any;
      document.body.appendChild(a);
      a.style = "display: none";
      a.href = url;
      a.download = "Rechnung.pdf";
      a.click();
      window.URL.revokeObjectURL(url);
    }, [userToken, customerId])

  return (
    <AdvancedForm form={form} name="customer-invoice" onFinish={() => {}} isLoading={false} originalValues={{}} initialEditing={!invoiceId}>
      <div style={{ textAlign: 'right' }}>
        <Space size="small">
          <Button type="primary" onClick={generatePdf}>
            PDF erstellen
          </Button>
        </Space>
      </div>
      <Row><h3>Rechnungsinformationen</h3></Row>
      <Row gutter={24}>
        <FormItem fieldName="date" label="Rechnungsdatum" type="date" />
      </Row>
      <Row><h3>Rechnungsposten</h3></Row>
      <Row><h3>Arbeitszeiten</h3></Row>
      <Row>
        <WorktimeTable as={ActionTableState} preselectedCustomerId={customerId} />
      </Row>
    </AdvancedForm>
  );
}

export default CustomerInvoiceDetails;